"use client";

import { Button } from "@/components/ui/button";
import {
   Card,
   CardContent,
   CardDescription,
   CardHeader,
   CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useAuthStore } from "@/store/authStore";
import { Fish, Lock, User } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function LoginPage() {
   const [username, setUsername] = useState("");
   const [password, setPassword] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const [error, setError] = useState("");
   const router = useRouter();
   const login = useAuthStore(state => state.login);

   const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      setIsLoading(true);
      setError("");

      try {
         await login(username, password);
         router.push("/");
      } catch (err: any) {
         setError(err.response?.data?.error || "Ошибка входа");
      } finally {
         setIsLoading(false);
      }
   };

   return (
      <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))] p-4">
         {/* Background decorations */}
         <div className="fixed inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-40 -right-40 w-96 h-96 bg-[hsl(var(--primary)/0.1)] rounded-full blur-3xl" />
            <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[hsl(25_95%_53%/0.1)] rounded-full blur-3xl" />
         </div>

         <Card className="w-full max-w-md relative animate-fade-in">
            <CardHeader className="text-center space-y-4">
               <div className="mx-auto w-16 h-16 rounded-2xl gradient-primary flex items-center justify-center shadow-lg shadow-[hsl(var(--primary)/0.3)]">
                  <Fish size={32} className="text-white" />
               </div>
               <div>
                  <CardTitle className="text-2xl text-gradient">
                     Topfish Admin
                  </CardTitle>
                  <CardDescription className="mt-2">
                     Введите данные для входа в панель управления
                  </CardDescription>
               </div>
            </CardHeader>
            <CardContent>
               <form onSubmit={handleSubmit} className="space-y-4">
                  {error && (
                     <div className="p-3 rounded-xl bg-red-500/10 border border-red-500/30 text-red-500 text-sm text-center animate-fade-in">
                        {error}
                     </div>
                  )}

                  <div className="space-y-2">
                     <label className="text-sm font-medium flex items-center gap-2">
                        <User
                           size={14}
                           className="text-[hsl(var(--muted-foreground))]"
                        />
                        Логин
                     </label>
                     <Input
                        type="text"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        placeholder="admin"
                        required
                        autoComplete="username"
                     />
                  </div>

                  <div className="space-y-2">
                     <label className="text-sm font-medium flex items-center gap-2">
                        <Lock
                           size={14}
                           className="text-[hsl(var(--muted-foreground))]"
                        />
                        Пароль
                     </label>
                     <Input
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        placeholder="••••••••"
                        required
                        autoComplete="current-password"
                     />
                  </div>

                  <Button type="submit" className="w-full" disabled={isLoading}>
                     {isLoading ? "Вход..." : "Войти"}
                  </Button>
               </form>
            </CardContent>
         </Card>
      </div>
   );
}
